import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'recreationarea',
    templateUrl: './recreationarea.component.html',
    styleUrls: ['./recreationarea.component.scss']
})
export class RecreationAreaComponent extends AdDefaults implements OnInit {

    @Input() info : any;
    @Input() plain : any = false;
    @Input() swiperConfig : any;

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }

    ngOnInit(){
        super.ngOnInit();
        if(this.info?.imagesRecreationArea?.length==1)
            this.swiperConfig.slidesPerView = 1;
    }

}